<template>
  <v-flex :class="!empresa_integrada ? 'mt-3' : ''">
    <v-btn
      color="primary"
      dark
      @click="openDialog"
      :block="!empresa_integrada"
      :rounded="!empresa_integrada"
      :large="!empresa_integrada"
      :icon="!!empresa_integrada"
      class="text-xs-start"
      :loading="loading"
      v-if="empresa_integrada ? empresa_integrada && [4, 5, 6].includes(empresa_integrada.tipo_empresa) : empresa && [4, 5, 6].includes(empresa.tipo_empresa)"
    >
      <v-icon left>mdi-cogs</v-icon>
      <span v-if="!empresa_integrada">Gerenciar Requisições</span>
    </v-btn>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row no-gutters>
          <v-col cols="12" md="5" class="pa-4">
            <h2 class="headline mb-4">Requisições Salvas</h2>
            <v-data-table
              :headers="headers"
              :items="requisicoes"
              :loading="loading"
              class="elevation-1"
              hide-default-footer
              :hide-default-header="!requisicoes.length"
            >
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)" color="primary">mdi-pencil</v-icon>
                <v-icon small @click="deleteItem(item)" color="error">mdi-delete</v-icon>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" md="7">
            <v-stepper v-model="stepper" vertical class="elevation-0">
              <v-stepper-step :complete="stepper > 1" step="1">
                Informações Gerais
                <small class="mt-1">Definições básicas da requisição</small>
              </v-stepper-step>
              <v-stepper-content step="1" class="pa-0 ma-0">
                <v-card flat class="mb-4 pa-2">
                  <v-text-field v-model="editedItem.nome" label="Nome da Requisição" outlined dense></v-text-field>
                  <v-text-field v-model="editedItem.url" label="URL do Endpoint" outlined dense></v-text-field>
                  <v-row>
                    <v-col cols="6">
                      <v-select
                        v-model="editedItem.method"
                        :items="methods"
                        label="Método HTTP"
                        outlined
                        dense
                      ></v-select>
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        v-model="editedItem.aplicacao_sistema"
                        :items="aplicacoes"
                        item-text="text"
                        item-value="value"
                        label="Aplicação no Sistema"
                        outlined
                        dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-card>
                <v-layout row justify-space-around>
                  <v-btn text @click="newItem" class="mb-4">Cancelar</v-btn>
                  <v-btn color="primary" @click="stepper = 2" class="mb-4">Continuar</v-btn>
                </v-layout>
              </v-stepper-content>
              <v-stepper-step :complete="stepper > 2" step="2">
                Headers
                <small class="mt-1">Chaves e valores para a requisição</small>
              </v-stepper-step>
              <v-stepper-content step="2" class="pa-0 ma-0">
                <v-card flat class="mb-4 pa-2">
                    <monaco-editor
                      v-model="editedItem.headers"
                      language="json"
                      height="300px"
                      theme="vs-dark"
                      :options="{ automaticLayout: true, formatOnType: true, formatOnPaste: true }"
                    />
                </v-card>
                <v-layout row justify-space-around>
                  <v-btn text @click="stepper = 1" class="mb-4">Voltar</v-btn>
                  <v-btn color="primary" @click="stepper = 3" class="mb-4">Continuar</v-btn>
                </v-layout>
              </v-stepper-content>
              <v-stepper-step :complete="stepper > 3" step="3">
                Parâmetros (Query Params)
                <small class="mt-1">Chaves e valores para a requisição</small>
              </v-stepper-step>
              <v-stepper-content step="3" class="pa-0 ma-0">
                <v-card flat class="mb-4 pa-2">
                    <monaco-editor
                      v-model="editedItem.params"
                      language="json"
                      height="300px"
                      theme="vs-dark"
                      :options="{ automaticLayout: true, formatOnType: true, formatOnPaste: true }"
                    />
                  <h5 class="error--text mt-2">Os parâmetros a serem preenchidos depois devem ser passado como "null".</h5>
                </v-card>
                <v-layout row justify-space-around>
                  <v-btn text @click="stepper = 2" class="mb-4">Voltar</v-btn>
                  <v-btn color="primary" @click="stepper = 4" class="mb-4">Continuar</v-btn>
                </v-layout>
              </v-stepper-content>
              <v-stepper-step :complete="stepper > 4" step="4">
                Corpo da Requisição (Body)
                <small class="mt-1">Conteúdo JSON para POST, PUT, PATCH</small>
              </v-stepper-step>
              <v-stepper-content step="4" class="pa-0 ma-0">
                  <monaco-editor
                    v-model="editedItem.body"
                    language="json"
                    height="300px"
                    theme="vs-dark"
                    :options="{ automaticLayout: true, formatOnType: true, formatOnPaste: true }"
                  />
                <h5 class="error--text mt-2 mb-4">Os parâmetros a serem preenchidos depois devem ser passado como "null".</h5>
                <v-layout row justify-space-around>
                  <v-btn text @click="stepper = 3" class="mb-4">Voltar</v-btn>
                  <v-btn color="primary" @click="stepper = 5" class="mb-4">Continuar para Mapeamento</v-btn>
                </v-layout>
              </v-stepper-content>
              <v-stepper-step step="5">
                Mapeamento do Retorno
                <small class="mt-1">Associe a resposta da API com os campos do sistema</small>
              </v-stepper-step>
              <v-stepper-content step="5" class="pa-0 ma-0">
                <v-card flat class="pa-2">
                    <p>Cole uma resposta JSON de exemplo abaixo ou clique em "Testar Requisição" para obter uma resposta real.</p>
                     <monaco-editor
                        v-model="sampleResponse"
                        language="json"
                        height="200px"
                        theme="vs-dark"
                        :options="{ automaticLayout: true, formatOnType: true, formatOnPaste: true }"
                     />
                     <div class="mt-2 mb-2">
                        <span class="font-weight-bold">Tipo de Retorno Detectado:</span>
                        <v-chip :color="tipoRetornoColor" small dark class="ml-2">
                          {{ tipo_retorno }}
                        </v-chip>
                      </div>
                    <v-btn small color="info" @click="testarRequisicao" :loading="loadingTest" class="my-2">
                        <v-icon left>mdi-play-network</v-icon>
                        Testar Requisição
                    </v-btn>
                    <v-divider class="my-4"></v-divider>
                    <v-alert
                      v-if="tipo_retorno === 'Lista (Array)'"
                      type="info"
                      text
                      dense
                      class="mb-4"
                    >
                      Detectamos uma lista! O mapeamento que você definir abaixo será aplicado a <strong>cada objeto</strong> dentro desta lista. Estamos usando o primeiro item como modelo.
                    </v-alert>
                    <v-row v-if="parsedSampleResponse">
                        <v-col cols="6">
                            <h4 class="mb-2">1. Clique em um valor na resposta da API:</h4>
                            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ccc; padding: 10px;">
                               <simple-json-tree
                                  :data="parsedSampleResponse"
                                  @node-click="handleJsonNodeClick"
                                ></simple-json-tree>
                            </div>
                        </v-col>

                        <v-col cols="6">
                            <h4 class="mb-2">2. Para mapear o campo:</h4>
                            <v-list dense>
                                <v-list-item-group v-model="campoAtivoParaMapear" color="primary">
                                    <v-list-item
                                      v-for="campo in camposDaAplicacao"
                                      :key="campo.key"
                                      :value="campo.key"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-title>{{ campo.label }}</v-list-item-title>
                                            <v-list-item-subtitle>
                                                Caminho: <strong>{{ editedItem.mapeamento[campo.key] || 'Não mapeado' }}</strong>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                            <div v-if="campoAtivoParaMapear" class="mt-3 pa-2 primary--text" style="background-color: #e3f2fd; border-radius: 4px;">
                                Mapeando o campo <strong>{{ nomeCampoAtivo }}</strong>. Clique em um valor na árvore JSON à esquerda.
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
                <v-layout row justify-space-around>
                  <v-btn text @click="stepper = 4" class="mb-4">Voltar</v-btn>
                  <v-btn color="primary" @click="save" :loading="loading" :disabled="loading" class="mb-4">Salvar Requisição</v-btn>
                </v-layout>
              </v-stepper-content>

            </v-stepper>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
// NOVO: Importar o JsonViewer e também o axios para o teste
import MonacoEditor from '@guolao/vue-monaco-editor'
import SimpleJsonTree from '@/components/SimpleJsonTree'

export default {
  name: 'RequisicoesManager',
  props: ['empresa_integrada'],
  components: {
    MonacoEditor,
    SimpleJsonTree
  },
  data: () => ({
    dialog: false,
    stepper: 1,
    headers: [
      { text: 'Nome', value: 'nome' },
      { text: 'Método', value: 'method' },
      { text: 'URL', value: 'url' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    requisicoes: [],
    methods: ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'],
    aplicacoes: [
      { text: 'Pegar Histórico de Vendas', value: 1 },
      { text: 'Pegar Produtos', value: 2 }
    ],
    editedIndex: -1,
    editedItem: {
      nome: '',
      url: '',
      method: 'GET',
      headers: '{\n  "Content-Type": "application/json"\n}',
      params: '{\n\n}',
      body: '{\n\n}',
      aplicacao_sistema: 1,
      mapeamento: {} // NOVO
    },
    defaultItem: {
      nome: '',
      url: '',
      method: 'GET',
      headers: '{\n  "Content-Type": "application/json"\n}',
      params: '{\n\n}',
      body: '{\n\n}',
      aplicacao_sistema: 1,
      mapeamento: {} // NOVO
    },
    // NOVO: Dados para o mapeamento
    loadingTest: false,
    sampleResponse: '{\n  "informacoes_compra": {\n    "id": 123,\n    "valor": "150,99",\n    "descricao": "Livro de Ficção Científica"\n  },\n  "data_compra": "2025-09-23"\n}',
    campoAtivoParaMapear: null,
    mapeamentosDisponiveis: {
      1: [ // Campos para "Pegar Histórico de Vendas"
        { key: 'identificacao', label: 'ID da Venda' },
        { key: 'valor_total', label: 'Valor Total' },
        { key: 'valor_com_desconto', label: 'Valor com desconto aplicado' },
        { key: 'descricao', label: 'Descrição' },
        { key: 'data', label: 'Data de realização' },
        { key: 'itens_vendidos', label: 'Itens vendidos' },
        { key: 'desconto_aplicado', label: 'Desconto aplicado' },
        { key: 'forma_pagamento', label: 'Forma de pagamento' },
        { key: 'cashback', label: 'Cashback ganho' }
      ],
      2: [ // Campos para "Pegar Produtos"
        { key: 'id', label: 'ID do Produto' },
        { key: 'nome', label: 'Nome do Produto' },
        { key: 'preco', label: 'Preço' },
        { key: 'qtd_estoque', label: 'Quantidade em estoque' },
        { key: 'disponivel', label: 'Produto está disponivel' },
        { key: 'imagens', label: 'Imagens do produto' },
        { key: 'descricao', label: 'Descrição do produto' },
        { key: 'categoria', label: 'Categoria do produto' },
        { key: 'sub_categoria', label: 'Sub categoria do produto' },
        { key: 'marca', label: 'Marca do produto' },
        { key: 'fabricante', label: 'Fabricante do produto' }
      ]
    }
  }),
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nova Requisição Externa' : 'Editar Requisição Externa'
    },
    loading () {
      return this.$store.state.loading
    },
    empresa () {
      return this.$store.getters.empresa
    },
    // NOVO: Computed properties para o mapeador
    parsedSampleResponse () {
      try {
        return JSON.parse(this.sampleResponse)
      } catch (e) {
        return null
      }
    },
    camposDaAplicacao () {
      return this.mapeamentosDisponiveis[this.editedItem.aplicacao_sistema] || []
    },
    nomeCampoAtivo () {
      if (!this.campoAtivoParaMapear) return ''
      const campo = this.camposDaAplicacao.find(c => c.key === this.campoAtivoParaMapear)
      return campo ? campo.label : ''
    },
    tipo_retorno () {
      if (!this.sampleResponse || this.sampleResponse.trim() === '') {
        return 'N/D' // Nenhum dado para analisar
      }
      try {
        const data = JSON.parse(this.sampleResponse)
        if (Array.isArray(data)) {
          return 'Lista (Array)'
        } else if (typeof data === 'object' && data !== null) {
          return 'Objeto Único'
        } else {
          return 'Tipo Primitivo (string, número, etc.)'
        }
      } catch (e) {
        return 'JSON Inválido'
      }
    },
    tipoRetornoColor () {
      switch (this.tipo_retorno) {
        case 'Lista (Array)':
        case 'Objeto Único':
          return 'green'
        case 'JSON Inválido':
          return 'red'
        default:
          return 'grey'
      }
    }
  },
  methods: {
    dadosParaMapeamento () {
      try {
        const data = JSON.parse(this.sampleResponse)
        if (Array.isArray(data)) {
          // Se for uma lista, pegamos apenas o PRIMEIRO item como modelo para o mapeamento
          return data.length > 0 ? data[0] : {}
        } else if (typeof data === 'object' && data !== null) {
          // Se for um objeto, usamos ele diretamente
          return data
        }
        return null // Não renderiza a árvore para JSON inválido ou tipos primitivos
      } catch (e) {
        return null
      }
    },
    async openDialog () {
      this.dialog = true
      await this.fetchRequisicoes()
    },
    closeDialog () {
      this.dialog = false
      this.$nextTick(() => {
        this.newItem()
      })
    },
    newItem () {
      this.editedIndex = -1
      // NOVO: Garante que o defaultItem seja clonado corretamente
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
      this.stepper = 1
    },
    fetchRequisicoes () {
      const payload = {
        method: 'GET',
        params: {}
      }
      if (this.empresa_integrada) {
        payload.params.empresa = this.empresa_integrada.cnpj
        payload.params.empresa_automacao = this.empresa.cnpj
      } else {
        payload.params.empresa = this.empresa.cnpj
      }
      this.$store.dispatch('gerenciarRequisicoesExternas', payload).then((json) => {
        this.requisicoes = Array.isArray(json) ? json : []
      })
    },
    editItem (item) {
      this.editedIndex = this.requisicoes.indexOf(item)
      const formatJSON = (data) => {
        if (typeof data === 'object' && data !== null) {
          return JSON.stringify(data, null, 2)
        }
        // Retorna um objeto JSON vazio como string se for nulo ou indefinido
        return data || '{\n\n}'
      }

      this.editedItem = {
        ...item,
        headers: formatJSON(item.headers),
        params: formatJSON(item.params),
        body: formatJSON(item.body),
        // NOVO: Garante que o mapeamento seja um objeto
        mapeamento: item.mapeamento || {}
      }

      if (this.empresa_integrada) {
        this.editedItem.empresa = this.empresa_integrada.cnpj
        this.editedItem.empresa_automacao = this.empresa.cnpj
      } else {
        this.editedItem.empresa = this.empresa.cnpj
      }

      this.stepper = 1
    },
    deleteItem (item) {
      if (confirm('Tem certeza que deseja deletar esta requisição?')) {
        const payload = {
          method: 'DELETE',
          params: {},
          id: item.id
        }
        if (this.empresa_integrada) {
          payload.params.empresa = this.empresa_integrada.cnpj
          payload.params.empresa_automacao = this.empresa.cnpj
        } else {
          payload.params.empresa = this.empresa.cnpj
        }
        this.$store.dispatch('gerenciarRequisicoesExternas', payload).then(() => {
          this.fetchRequisicoes()
        })
      }
    },
    parseJSON (jsonString, fieldName) {
      try {
        if (!jsonString || jsonString.trim() === '' || jsonString.trim() === '{}') {
          return {}
        }
        return JSON.parse(jsonString)
      } catch (e) {
        alert(`O JSON no campo '${fieldName}' é inválido. Por favor, corrija antes de salvar.`)
        return null
      }
    },
    save () {
      const headersParsed = this.parseJSON(this.editedItem.headers, 'Headers')
      const paramsParsed = this.parseJSON(this.editedItem.params, 'Parâmetros')
      const bodyParsed = this.parseJSON(this.editedItem.body, 'Body')
      if (headersParsed === null || paramsParsed === null || bodyParsed === null) {
        return
      }
      let tipoRetornoParaSalvar = null
      if (this.tipo_retorno === 'Lista (Array)') {
        tipoRetornoParaSalvar = 'array'
      } else if (this.tipo_retorno === 'Objeto Único') {
        tipoRetornoParaSalvar = 'object'
      }
      const payload = {
        method: this.editedIndex === -1 ? 'POST' : 'PUT', // NOVO: Lógica para PUT em edição
        id: this.editedIndex === -1 ? undefined : this.editedItem.id, // NOVO: Passa o ID na edição
        body: {
          ...this.editedItem,
          headers: headersParsed,
          params: paramsParsed,
          body: bodyParsed,
          tipo_retorno: tipoRetornoParaSalvar
        }
      }
      if (this.empresa_integrada) {
        payload.body.empresa = this.empresa_integrada.cnpj
        payload.body.empresa_automacao = this.empresa.cnpj
      } else {
        payload.body.empresa = this.empresa.cnpj
      }
      this.$store.dispatch('gerenciarRequisicoesExternas', payload).then(() => {
        this.fetchRequisicoes()
        this.newItem()
      })
    },
    // --- MÉTODOS NOVOS PARA O MAPEAMENTO ---
    handleJsonNodeClick (data) {
      if (this.campoAtivoParaMapear) {
        // Nosso evento emite um objeto { path, key, value }
        const cleanPath = data.path // O caminho já vem limpo!

        console.log('✅✅✅ FINALMENTE FUNCIONOU!!! ✅✅✅')
        console.log('Campo Ativo:', this.campoAtivoParaMapear)
        console.log('Dados do Clique:', data)
        console.log('Caminho Mapeado:', cleanPath)

        this.$set(this.editedItem.mapeamento, this.campoAtivoParaMapear, cleanPath)
        this.campoAtivoParaMapear = null
      }
    },
    async testarRequisicao () {
      this.loadingTest = true
      try {
        const headers = this.parseJSON(this.editedItem.headers, 'Headers')
        const params = this.parseJSON(this.editedItem.params, 'Parâmetros')
        const body = this.parseJSON(this.editedItem.body, 'Body')

        // Validação simples
        if (!this.editedItem.url) {
          alert('Por favor, informe a URL do Endpoint no Passo 1.')
          return
        }

        // Monta a URL com os query params
        const url = new URL(this.editedItem.url)
        if (params) {
          Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))
        }

        const config = {
          method: this.editedItem.method,
          headers: headers
        }

        // Adiciona o body apenas para métodos que o permitem
        if (['POST', 'PUT', 'PATCH'].includes(this.editedItem.method.toUpperCase())) {
          config.body = JSON.stringify(body)
        }

        const response = await fetch(url, config)

        // O fetch não lança erro para status 4xx/5xx, então precisamos verificar manualmente
        if (!response.ok) {
          // Tenta ler o corpo do erro como JSON, se falhar, usa o texto do status
          let errorBody = `HTTP error! Status: ${response.status} ${response.statusText}`
          try {
            const errorJson = await response.json()
            errorBody = JSON.stringify(errorJson, null, 2)
          } catch (e) {
            // O corpo do erro não era JSON, o statusText é suficiente
          }
          throw new Error(errorBody)
        }

        const responseData = await response.json()
        this.sampleResponse = JSON.stringify(responseData, null, 2)
      } catch (error) {
        console.error('Erro ao testar requisição:', error)
        this.sampleResponse = `// Ocorreu um erro:\n${error.message}`
        alert('Falha ao executar a requisição. Verifique as configurações, a URL e o console para mais detalhes.')
      } finally {
        this.loadingTest = false
      }
    }
  }
}
</script>

<style scoped>
.v-stepper {
  border-left: 1px solid rgba(0,0,0,0.12)
}
/* NOVO: Estilo para destacar o caminho do JSON no viewer */
/deep/ .jv-node:hover {
  background-color: #f0f0f0;
}
</style>
